module.exports = __webpack_public_path__ + "img/Monte_Kope_52.cdc8d64b.jpg";